import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the admin secret to every request when signed in — enables server-side
// enforcement on /api/expenses/* and any other admin-guarded endpoints.
// Portal auth uses an httpOnly cookie set by the backend (withCredentials above),
// with a JWT bearer header fallback stored in localStorage under `elevare_portal_token`.
api.interceptors.request.use((config) => {
  try {
    const s = typeof window !== "undefined" && localStorage.getItem("elevare_admin_secret");
    if (s) {
      config.headers = config.headers || {};
      config.headers["X-Admin-Secret"] = s;
    }
    const t = typeof window !== "undefined" && localStorage.getItem("elevare_portal_token");
    if (t) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${t}`;
      }
    }
  } catch (_) { /* ignore */ }
  return config;
});

// On a 401 from an admin route, refresh the session once and retry the request.
let refreshing = null;
const NO_RETRY = ["/admin-auth/login", "/admin-auth/refresh", "/admin-auth/logout", "/admin/login"];
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err?.config;
    const url = cfg?.url || "";
    const isAdmin = url.startsWith("/admin");
    if (err?.response?.status !== 401 || !cfg || cfg._retried || !isAdmin || NO_RETRY.some((p) => url.startsWith(p))) {
      return Promise.reject(err);
    }
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/admin-auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
    } catch (_) {
      return Promise.reject(err);
    }
    return api(cfg);
  },
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
